/** Google Play — app Adatis produção (`br.com.adatis.professional`). */
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=br.com.adatis.professional";

export const PLAY_STORE_WELCOME_QUERY = "welcome";
export const PLAY_STORE_WELCOME_VALUE = "app";
export const PLAY_STORE_WELCOME_DISMISS_KEY = "adatis.playStore.welcome.dismissed";
